import PropTypes from "prop-types";
import React from 'react'

const SEO = ( {title, structuredData, ogTitle, ogDescription, ogUrl, ogType, ogImage} ) => {
    const schemas = Array.isArray(structuredData) ? structuredData : (structuredData ? [structuredData] : []);
    return (
        <>
            <meta charSet="utf-8" />
            <title>{title} || We are a 360 degree software solution provider.</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="We are a 360 degree software solution provider." />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            {ogTitle && <meta property="og:title" content={ogTitle} />}
            {ogDescription && <meta property="og:description" content={ogDescription} />}
            {ogUrl && <meta property="og:url" content={ogUrl} />}
            {ogType && <meta property="og:type" content={ogType} />}
            {ogImage && <meta property="og:image" content={ogImage} />}
            {schemas.map((schema, idx) => (
                <script
                    key={idx}
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: typeof schema === 'string' ? schema : JSON.stringify(schema)
                    }}
                />
            ))}
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string,
    structuredData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string
    ]),
    ogTitle: PropTypes.string,
    ogDescription: PropTypes.string,
    ogUrl: PropTypes.string,
    ogType: PropTypes.string,
    ogImage: PropTypes.string
};

export default SEO;


